import script from "./LeaderProjectFormStep7.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderProjectFormStep7.vue?vue&type=script&setup=true&lang=js"

import "./LeaderProjectFormStep7.vue?vue&type=style&index=0&id=3647a480&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3647a480"]])

export default __exports__